import { requestJson } from "./apiClient";

const BASE = "/api/admin/transport/jobs";

export async function fetchTransportJobsSummary(options = {}) {
  return requestJson(`${BASE}/summary`, { signal: options.signal });
}

export async function fetchTransportSchedulerJobs(options = {}) {
  return requestJson(BASE, { signal: options.signal });
}

export async function fetchTransportJobDetail(jobKey, options = {}) {
  return requestJson(`${BASE}/${encodeURIComponent(jobKey)}`, { signal: options.signal });
}

export async function fetchTransportJobRuns(jobKey, params = {}, options = {}) {
  const search = new URLSearchParams();
  if (params.limit) search.set("limit", String(params.limit));
  const qs = search.toString();
  return requestJson(`${BASE}/${encodeURIComponent(jobKey)}/runs${qs ? `?${qs}` : ""}`, {
    signal: options.signal,
  });
}

export async function runTransportJobNow(jobKey, body = {}, options = {}) {
  return requestJson(`${BASE}/${encodeURIComponent(jobKey)}/run`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: { "Content-Type": "application/json" },
    signal: options.signal,
  });
}

export async function patchTransportJobSchedule(jobKey, body, options = {}) {
  return requestJson(`${BASE}/${encodeURIComponent(jobKey)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
    headers: { "Content-Type": "application/json" },
    signal: options.signal,
  });
}
